import React, { useEffect, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import { Paper, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { NormalizedCargo } from "../../../../../../../domain/models/cargo-model";
import { useDispatch } from "react-redux";
import { checkShipmentActions } from "../../store";
import { useNavigate } from "react-router-dom";

type Props = {
  cargo: NormalizedCargo;
};

type Status = {
  name: "Não Iniciada" | "Em Andamento" | "Separada";
  color: "error" | "success" | "warning";
  button: "Iniciar" | "Continuar" | "Ver";
};

export const CargoCard: React.FC<Props> = ({ cargo }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const separationStatus: Status = useMemo(() => {
    let hasSeparated = false;
    let hasNotSeparated = false;
    cargo.cargoItems.forEach((item) => {
      item.inventoryReservations?.forEach((reservation) => {
        if (reservation.status === "NOT_SEPARATED") {
          hasNotSeparated = true;
        }
        if (reservation.status === "SEPARATED") {
          hasSeparated = true;
        }
      });
    });

    if (hasSeparated && hasNotSeparated)
      return { name: "Em Andamento", color: "warning", button: "Continuar" };
    if (hasNotSeparated && !hasSeparated)
      return { name: "Não Iniciada", color: "error", button: "Iniciar" };
    return { name: "Separada", color: "success", button: "Ver" };
  }, []);

  return (
    <Paper sx={{ p: "20px", minHeight: "100px" }}>
      <Stack direction="row">
        <Box
          sx={{
            width: "60%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "120px",
          }}
        >
          <Stack>
            <Typography>{`Carga: ${cargo.reference}`}</Typography>
            <Typography fontWeight="bold" fontSize="20px">
              {cargo.clientName}
            </Typography>
            <Typography>{`Quantidade de Itens: ${cargo.cargoItems.length}`}</Typography>
          </Stack>
        </Box>
        <Box
          sx={{
            width: "40%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-around",
          }}
        >
          <Chip
            label={separationStatus.name}
            variant="outlined"
            color={separationStatus.color}
            size="small"
          />
          <Chip
            label={cargo.status === "CHECKED" ? "Conferida" : "Não Conferida"}
            variant="outlined"
            color={cargo.status === "CHECKED" ? "success" : "error"}
            size="small"
          />
          <Button
            variant="contained"
            disabled={
              cargo.status === "CHECKED" || separationStatus.name !== "Separada"
            }
            onClick={() => {
              dispatch(
                checkShipmentActions.setCargoId({ cargoId: cargo.id as number })
              );
              navigate("collector");
            }}
          >
            Conferir
          </Button>
        </Box>
      </Stack>
    </Paper>
  );
};
